import React, {useState, useEffect, useContext} from 'react'
import {useSelector} from 'react-redux'
import {Link} from 'react-router-dom'
import {ContextApp} from '../context/ContextApp'
import Spinner from './Spinner'

import promo3 from '../assets/banner/1.jpg'

export default ({match}) => {
  const contextApp = useContext(ContextApp)
  const {
    cleanPaginateCount,
    paginate,
    getProductsByCategoryBussinessProv,
    categories,
    productsByCategory,
    addProductToCarShoppingById,
    productsBySearch,
    setCategoryShowClose,
    getProductsBySubCategory,
    setShowNav,
    productsByProvider,
    getProductsByProviderAndCategory,
    provider_name,
    cleanNameOfProvider,
    reloadProductsByCategory,
    productsBySubCategory,
    getCategoryNameFromMenu,
    resetRealoadProductsByCategory,
    cleanProductsBySubCategory,
    categoryNameFromMenu,
    getProductsByCategory,
    contador,
    getProductsByProviderID,
  } = contextApp
  const {id} = match.params

  let providerID = id

  let val = 10
  let prove = ''
  val = val + contador.correlativo
  prove = contador.id

  const [value, setValue] = useState(false)
  const [option, setOption] = useState(false)
  const [min, setMin] = useState('')
  const [max, setMax] = useState('')
  const [buscarPrice, setbuscarPrice] = useState(false)

  useEffect(() => {
    setCategoryShowClose()
    getProductsByProviderID(id, val)

    return function cleanProviderName() {
      cleanNameOfProvider()
    }
  }, [id])

  const handleProductsByCategoryProvider = categoryID => {
    getProductsByProviderAndCategory(categoryID, parseInt(providerID))
  }

  const listCategories = categories.filter(
    category => category.enabled == 1 && category.id !== 65,
  )

  let provePrice = []

  productsByProvider.forEach(element => {
    if (provePrice.indexOf(element.batches.unit_price) == -1) {
      provePrice.push(element.batches.unit_price)
    }
  })

  const handleChangeMin = e => {
    setMin(e.target.value)
  }
  const handleChangeMax = e => {
    setMax(e.target.value)
  }
  const handleSearchPrice = () => {
    if (min >= 0 && max > 0) {
      if (max > min) {
        setValue(true)
        let items = []
        let itemsList = []

        productsByProvider.forEach(element => {
          element.batches.forEach(elementBatches => {
            items.push(elementBatches)
          })
        })

        const result = items.filter(
          batches =>
            parseFloat(batches.unit_price) >= parseFloat(min) &&
            parseFloat(batches.unit_price) <= parseFloat(max),
        )

        result.forEach(element => {
          // var precio = element.unit_price

          //if(precio >= min &&  precio <=max ) {
          if (itemsList.indexOf(element) == -1) {
            itemsList.push(element)
          }
          //}
        })

        let productolist = []

        itemsList.forEach(element => {
          productsByProvider.forEach(elementPrincipal => {
            if (elementPrincipal.id == element.product_id) {
              if (productolist.indexOf(elementPrincipal) == -1) {
                productolist.push(elementPrincipal)
              }
            }
          })
        })

        getProductsByCategoryBussinessProv(productolist, val)
        setbuscarPrice(true)
      } else {
        setMin('')
        setMax('')
      }
    } else {
      setMin('')
      setMax('')
    }
  }

  const handleSearchPriceDesc = () => {
    setbuscarPrice(false)
    setValue(false)
    setMin('')
    setMax('')
    getProductsByProviderID(providerID, val)
  }

  const [isCheckedOR1, setIsCheckedOR1] = useState(false)
  const [isCheckedOR2, setIsCheckedOR2] = useState(false)
  const [isCheckedOR3, setIsCheckedOR3] = useState(false)
  const [isCheckedOR4, setIsCheckedOR4] = useState(false)

  function handleCheckedOR(event) {
    //console.log(productsByCategory.sort((a, b) => parseFloat(a.batches.unit_price) - parseFloat(b.batches.unit_price)))

    let prove = []
    let proveOrder = []
    productsByProvider.forEach(element => {
      element.batches.forEach(elementBatches => {
        prove.push(elementBatches)
      })
    })

    if (event.target.id == 1) {
      //desc
      setIsCheckedOR1(!isCheckedOR1)

      if (!isCheckedOR1 == true) {
        proveOrder = prove.sort(
          (a, b) => parseFloat(a.unit_price) - parseFloat(b.unit_price),
        )
      } else {
        getProductsByProviderID(providerID, val)
      }
    } else if (event.target.id == 2) {
      //asc
      setIsCheckedOR2(!isCheckedOR2)

      if (!isCheckedOR2 == true) {
        proveOrder = prove.sort(
          (a, b) => parseFloat(b.unit_price) - parseFloat(a.unit_price),
        )
      } else {
        getProductsByProviderID(providerID, val)
      }
    } else if (event.target.id == 3) {
      //asc date
      setIsCheckedOR3(!isCheckedOR3)

      if (!isCheckedOR3 == true) {
        proveOrder = prove.sort(
          (a, b) => Date(a.created_at) - Date(b.created_at),
        )
      } else {
        getProductsByProviderID(providerID, val)
      }
    } else if (event.target.id == 4) {
      //desc date
      setIsCheckedOR4(!isCheckedOR4)

      if (!isCheckedOR4 == true) {
        proveOrder = prove.sort(
          (a, b) => Date(b.created_at) - Date(a.created_at),
        )
      } else {
        getProductsByProviderID(providerID, val)
      }
    }
    if (
      (isCheckedOR1 == false) &
      (isCheckedOR2 == false) &
      (isCheckedOR3 == false) &
      (isCheckedOR4 == false)
    ) {
      let productolist = []

      proveOrder.forEach(element => {
        productsByProvider.forEach(elementPrincipal => {
          if (elementPrincipal.id == element.product_id) {
            if (productolist.indexOf(elementPrincipal) == -1) {
              productolist.push(elementPrincipal)
            }
          }
        })
      })
      getProductsByCategoryBussinessProv(productolist)
    }
  }

  function MasNuevo(items, itemsList) {
    const sorting = items.sort((a, b) => {
      const aDate = new Date(a.created_at)
      const bDate = new Date(b.created_at)

      return bDate.getTime() - aDate.getTime()
    })

    let productolist = []
    sorting.forEach(element => {
      productsByProvider.forEach(elementPrincipal => {
        if (elementPrincipal.id == element.product_id) {
          if (productolist.indexOf(elementPrincipal) == -1) {
            productolist.push(elementPrincipal)
          }
        }
      })
    })
    getProductsByCategoryBussinessProv(productolist)
  }

  function MasAntiguo(items, itemsList) {
    const sorting = items.sort((a, b) => {
      const aDate = new Date(a.created_at)
      const bDate = new Date(b.created_at)

      return aDate.getTime() - bDate.getTime()
    })

    let productolist = []
    sorting.forEach(element => {
      productsByProvider.forEach(elementPrincipal => {
        if (elementPrincipal.id == element.product_id) {
          if (productolist.indexOf(elementPrincipal) == -1) {
            productolist.push(elementPrincipal)
          }
        }
      })
    })
    getProductsByCategoryBussinessProv(productolist)
  }

  function PrecioMasMinimo(items, itemsList) {
    itemsList = items.sort(
      (a, b) => parseFloat(a.unit_price) - parseFloat(b.unit_price),
    )

    let productolist = []

    itemsList.forEach(element => {
      productsByProvider.forEach(elementPrincipal => {
        if (elementPrincipal.id == element.product_id) {
          if (productolist.indexOf(elementPrincipal) == -1) {
            productolist.push(elementPrincipal)
          }
        }
      })
    })
    getProductsByCategoryBussinessProv(productolist)
  }

  function PrecioMasAlto(items, itemsList) {
    itemsList = items.sort(
      (a, b) => parseFloat(b.unit_price) - parseFloat(a.unit_price),
    )

    let productolist = []

    itemsList.forEach(element => {
      productsByProvider.forEach(elementPrincipal => {
        if (elementPrincipal.id == element.product_id) {
          if (productolist.indexOf(elementPrincipal) == -1) {
            productolist.push(elementPrincipal)
          }
        }
      })
    })
    getProductsByCategoryBussinessProv(productolist)
  }

  const handleFilterView = e => {
    let items = []
    let itemsList = []
    productsByProvider.forEach(element => {
      element.batches.forEach(elementBatches => {
        items.push(elementBatches)
      })
    })
    setOption(e.target.value)
    switch (e.target.value) {
      case '1':
        PrecioMasMinimo(items, itemsList)
        break
      case '2':
        PrecioMasAlto(items, itemsList)
        break
      case '3':
        MasNuevo(items, itemsList)
        break
      case '4':
        MasAntiguo(items, itemsList)
        break
      default:
        getProductsByProviderID(providerID, val)
        break
    }
  }

  const handlePriceFilter = value => {
    console.log('MAYOR' + value.max)
    console.log('MENOR' + value.min)
  }

  return (
    <main id="content" role="main">
      <div class="bg-gray-13 bg-md-transparent">
        <div class="container">
          <div class="my-md-3">
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb mb-3 flex-nowrap flex-xl-wrap overflow-auto overflow-xl-visble">
                <li class="breadcrumb-item flex-shrink-0 flex-xl-shrink-1">
                  <a href="../index.html">Home</a>
                </li>
                <span>
                  <i class="fas fa-chevron-right"></i>
                </span>
                <li
                  class="breadcrumb-item flex-shrink-0 flex-xl-shrink-1 active"
                  aria-current="page"
                >
                  Comercio {provider_name}
                </li>
              </ol>
            </nav>
          </div>
        </div>
      </div>

      {productsByProvider.length === 0 && provider_name == null ? (
        <Spinner />
      ) : (
        <div class="container">
          <div class="row mb-8">
            <div class="d-none d-xl-block col-xl-3 col-wd-2gdot5">
              <div class="mb-8 border border-width-2 border-color-3 borders-radius-6">
                <ul id="sidebarNav" class="list-unstyled mb-0 sidebar-navbar">
                  <li>
                    <a class="dropdown-current active" href="#">
                      Categorías{' '}
                      <span class="text-gray-25 font-size-12 font-weight-normal"></span>
                    </a>

                    <ul class="list-unstyled dropdown-list">
                      {listCategories.map(category => (
                        <li class="border-color-1 list-group-item border-lg-down-0 flex-shrink-0 flex-xl-shrink-1">
                          <Link
                            to={`/product_list/${category.name}`}
                            class="nav-link u-header__nav-link"
                            aria-haspopup="true"
                            aria-expanded="false"
                            onClick={() => {
                              getProductsByCategory(
                                category.id,
                                category,
                                category.name,
                                paginate,
                              )
                            }}
                          >
                            {category.name}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </li>
                </ul>
              </div>
              <div className="range-slider">
                <h3 className="font-size-18 mb-3 font-weight-bold">
                  Rango de precio
                </h3>
                <div
                  class="border rounded-pill py-1 w-md-40 height-35 px-3 border-color-1"
                  style={{margin: '5px'}}
                >
                  <div class="js-quantity row align-items-center">
                    <div class="col">
                      <input
                        value={min}
                        disabled={value == true ? 'disabled' : ''}
                        class="js-result form-control h-auto border-0 rounded p-0 shadow-none"
                        id="pMin"
                        name="pMin"
                        type="number"
                        min="1"
                        max="100"
                        placeholder="Min."
                        onChange={e => handleChangeMin(e)}
                      />
                    </div>
                  </div>
                </div>
                <div
                  class="border rounded-pill py-1 w-md-40 height-35 px-3 border-color-1"
                  style={{margin: '5px'}}
                >
                  <div class="js-quantity row align-items-center">
                    <div class="col">
                      <input
                        value={max}
                        disabled={value == true ? 'disabled' : ''}
                        class="js-result form-control h-auto border-0 rounded p-0 shadow-none"
                        id="pMax"
                        name="pMax"
                        type="number"
                        min="1"
                        max="100"
                        placeholder="Max."
                        onChange={e => handleChangeMax(e)}
                      />
                    </div>
                  </div>
                </div>

                {!buscarPrice ? (
                  <button
                    style={{margin: '5px'}}
                    type="submit"
                    onClick={handleSearchPrice}
                    class="btn px-4 btn-primary-dark-w py-2 rounded-lg"
                  >
                    <span style={{color: 'white'}}>Filtrar</span>
                  </button>
                ) : (
                  <button
                    type="submit"
                    style={{margin: '5px'}}
                    onClick={handleSearchPriceDesc}
                    class="btn px-4 btn-primary-dark-w py-2 rounded-lg"
                  >
                    <span style={{color: 'white'}}>Borrar filtro</span>
                  </button>
                )}
              </div>
            </div>
            {/** */}
            <div class="col-xl-9 col-wd-9gdot5">
              <div class="d-block d-md-flex flex-center-between mb-3">
                <h3 class="font-size-25 mb-2 mb-md-0">
                  Productos de <strong> {provider_name} </strong>
                </h3>
                <p class="font-size-14 text-gray-90 mb-0"></p>
              </div>
              <div class="bg-gray-1 flex-center-between borders-radius-9 py-1">
                <div class="d-xl-none">
                  <a
                    id="sidebarNavToggler1"
                    class="btn btn-sm py-1 font-weight-normal"
                    href="javascript:;"
                    role="button"
                    aria-controls="sidebarContent1"
                    aria-haspopup="true"
                    aria-expanded="false"
                    data-unfold-event="click"
                    data-unfold-hide-on-scroll="false"
                    data-unfold-target="#sidebarContent1"
                    data-unfold-type="css-animation"
                    data-unfold-animation-in="fadeInLeft"
                    data-unfold-animation-out="fadeOutLeft"
                    data-unfold-duration="500"
                  >
                    <i class="fas fa-sliders-h"></i>{' '}
                    <span class="ml-1">Filters</span>
                  </a>
                </div>
                <div class="px-3 d-none d-xl-block">
                  <ul class="nav nav-tab-shop" id="pills-tab" role="tablist">
                    <li class="nav-item">
                      <a
                        class="nav-link"
                        id="pills-one-example1-tab"
                        data-toggle="pill"
                        href="#pills-one-example1"
                        role="tab"
                        aria-controls="pills-one-example1"
                        aria-selected="false"
                      >
                        <div class="d-md-flex justify-content-md-center align-items-md-center">
                          <i class="fa fa-th"></i>
                        </div>
                      </a>
                    </li>
                  </ul>
                </div>
                <div class="d-flex">
                  <form method="get">
                    <select
                      class="border rounded-pill py-1 w-md-90 height-35 px-3 border-color-1"
                      data-style="btn-sm bg-white font-weight-normal py-2 border text-gray-20 bg-lg-down-transparent border-lg-down-0"
                      onChange={handleFilterView}
                    >
                      <option value="0" selected>
                        Ordenar productos por :
                      </option>
                      <option value="1">
                        Ordenar por: Precio de más bajo a más alto
                      </option>
                      <option value="2">
                        Ordenar por: Precio de más alto a más bajo{' '}
                      </option>
                      <option value="3">Ordenar por: Lo Más Nuevo</option>
                      <option value="4">Ordenar por: Lo Más Antiguo</option>
                    </select>
                  </form>
                </div>
              </div>

              <div class="tab-content" id="pills-tabContent">
                <div
                  class="tab-pane fade pt-2 show active in"
                  id="pills-one-example1"
                  role="tabpanel"
                  aria-labelledby="pills-one-example1-tab"
                  data-target-group="groups"
                >
                  <ul class="row list-unstyled products-group no-gutters">
                    {productsByProvider.map((product, index) => {
                      return (
                        <li
                          key={index}
                          className="col-6 col-md-4 col-wd-3 product-item"
                        >
                          <div class="product-item__outer h-100">
                            <div class="product-item__inner bg-white p-3">
                              <div class="product-item__body pb-xl-2">
                                <div class="mb-2">
                                  <Link
                                    to={`/products/provider/${product.batches[0].provider.id}`}
                                    class="font-size-12 text-gray-5"
                                  >
                                    {product.batches[0].provider.name}
                                  </Link>
                                </div>
                                <Link
                                  to={`/productos/${product.aeromall_categories && product.aeromall_categories.length > 0 ? product.aeromall_categories[0]?.slug : 'general'}/${product.slug}/${product.id}`}
                                  class="text-blue font-weight-bold"
                                >
                                  {' '}
                                  <h5 class="mb-1 product-item__title">
                                    {product.name}
                                  </h5>
                                  <div class="mb-2">
                                    <a class="d-block text-center">
                                      {product.campaing?.active == 1 ? (
                                        <span class="onsale">
                                          <span class="percentage">
                                            {product.campaing?.discount} % OFF
                                            {/* (((product.batches[0]?.regular_price-(product.batches[0].regular_price - (product.batches[0].regular_price*(product.campaing?.discount/100))).toFixed(2))/product.batches[0]?.regular_price)*100).toFixed(2) % OFF*/}
                                          </span>
                                        </span>
                                      ) : (
                                        ''
                                      )}
                                      <img
                                        style={{with: '100%'}}
                                        src={product.image_url}
                                        alt="Image Description"
                                      />
                                    </a>
                                  </div>
                                </Link>
                                <div class="flex-center-between mb-1">
                                  <div class="prodcut-price d-flex align-items-center position-relative">
                                  <ins class="font-size-20 tex-gray-6 text-decoration-none">
                                      {' '}
                                      {product.promo_price ? (
                                        <div className="discount_amount_promo_price">
                                          <strong>${product.promo_price}</strong>
                                          <span>{product?.batches[0]?.unit_price}</span>
                                        </div>
                                      ): `$${product?.batches[0]?.unit_price}`}
                                    </ins>    
                                    {product.promo_price ? <span className="discount_promo_price">Descuento del {product.active_campaign.discount_percentage.slice(0,2)}%</span> : null }         
                                  </div>
                                  <div class="d-none d-xl-block prodcut-add-cart"></div>
                                </div>
                              </div>
                            </div>
                            {product.batches[0]?.stock === 0 ? (
                              <div className="none_stock_alert_product_item">
                                <span>agotado</span>
                              </div>
                            ) : null}
                            
                          
                          </div>
                          {product.promo_price ? (
                                  <div className="promo_price_show">
                                    <span>Promoción</span>
                                  </div>
                                ): null}
                        </li>
                      )
                    })}
                  </ul>
                </div>
              </div>
              <nav></nav>
            </div>
          </div>
        </div>
      )}
    </main>
  )
}
